/*
 * Tipos de PDF para su descarga y consulta en la tabla
 */
export const PDF_ACTA_INICIO = 1;
export const PDF_ACTA_HALLAZGO = 2;
export const PDF_ACTA_CIERRE = 3;
export const PDF_MEDIOS_IMPRESOS = 4;
export const PDF_INTERNET = 5;
export const PDF_EVENTOS = 6;
export const PDF_CASAS = 7;
